import { render } from "./activityData.vue?vue&type=template&id=24d85619&scoped=true"
import script from "./activityData.vue?vue&type=script&lang=js"
export * from "./activityData.vue?vue&type=script&lang=js"

import "./activityData.vue?vue&type=style&index=0&id=24d85619&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d85619"]])

export default __exports__